var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/av/loop_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/loop_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.05168V7.33335C30.1033 7.33335 36.6667 13.8967 36.6667 22C36.6667 23.9067 36.3 25.74 35.6217 27.4083C35.1267 28.6367 33.55 28.9667 32.615 28.0317C32.12 27.5367 31.9183 26.785 32.1933 26.125C32.725 24.86 33 23.4483 33 22C33 15.9317 28.0683 11 22 11V14.2817C22 15.1067 21.01 15.51 20.4233 14.9417L15.3083 9.82668C14.9417 9.46002 14.9417 8.89168 15.3083 8.52502L20.4417 3.41002C21.01 2.82335 22 3.22668 22 4.05168ZM11 21.9999C11 28.0683 15.9316 32.9999 22 32.9999V29.7183C22 28.8933 22.99 28.4899 23.5583 29.0583L28.6733 34.1733C29.04 34.5399 29.04 35.1083 28.6733 35.4749L23.5583 40.5899C22.99 41.1766 22 40.7733 22 39.9483V36.6666C13.8966 36.6666 7.33331 30.1033 7.33331 21.9999C7.33331 20.0933 7.69998 18.2599 8.37831 16.5916C8.87331 15.3633 10.45 15.0333 11.385 15.9683C11.88 16.4633 12.0816 17.2149 11.8066 17.8749C11.275 19.1399 11 20.5516 11 21.9999Z",
    fill: "black",
    fillOpacity: 0.18
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.7fc060c57219685bd63c15034a86ac6f.svg";
export { ForwardRef as ReactComponent };